import type {
  PrismView,
  PrismViewPreference,
} from "@/features/chat/components/prism-retrieval/prism-retrieval-constants"

type PrismViewOption<TValue extends string> = {
  value: TValue
  labelKey: string
  fallback: string
}

/** The five Prism views, labelled; shared by Preferences and the admin default. */
export const PRISM_VIEW_OPTIONS: PrismViewOption<PrismView>[] = [
  {
    value: "levels",
    labelKey: "personalization.preferences.prismView.options.levels",
    fallback: "Levels",
  },
  {
    value: "focus",
    labelKey: "personalization.preferences.prismView.options.focus",
    fallback: "Focus panel",
  },
  {
    value: "access",
    labelKey: "personalization.preferences.prismView.options.access",
    fallback: "Access panel",
  },
  {
    value: "depth",
    labelKey: "personalization.preferences.prismView.options.depth",
    fallback: "Depth of field",
  },
  {
    value: "flow",
    labelKey: "personalization.preferences.prismView.options.flow",
    fallback: "Flow row",
  },
]

/** The user's choices: the company default first, then each view. */
export const PRISM_VIEW_PREFERENCE_OPTIONS: PrismViewOption<PrismViewPreference>[] = [
  {
    value: "company",
    labelKey: "personalization.preferences.prismView.options.company",
    fallback: "Company default",
  },
  ...PRISM_VIEW_OPTIONS,
]
